const handleCloseDialogModalEquipService = {
  confirm: 'Your unsaved information will be lost.',
  title: 'Exit?',
}

export default handleCloseDialogModalEquipService;
